module.exports = __webpack_public_path__ + "img/Futurism-text.6b4d9c43.jpg";